<template lang="pug">
  .room.dehumidifier(v-loading="loadingData")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData" :class="warningFlag1")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts1" :series="SingleSolidPieData1" :class="warningFlag4")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts2" :series="SingleSolidPieData2" :class="warningFlag5")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts3" :series="SingleSolidPieData3" :class="warningFlag6")
    .divice-block-line
      .divice-block-line-item
        single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts0" :series="SingleSolidPieData0" :class="warningFlag2")
        single-histogram.divice-block-multi-item(:opts="singleHisOpts" :series="flowData" :class="warningFlag3")
      .divice-block-line-item.divice-block-line-item-col
        .divice-block-line-item-col-top
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(title="高压风机运行" :series="SwitchStatusData1")
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(title="高压风机故障" :series="SwitchStatusData2")
        RunningTimeBig.divice-block-time(title="高压风机运行时间" :series="RunningTimeData")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/highPressureFanLess_data.json'

export default {
  name: 'highPressureFanLess',
  data() {
    return {
      timer: null,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      deviceList: [],
      flowData: {},
      singleHisOpts: {
        title: '高压风机出口流量',
        histogramName1: 'Flow',
        max: 229,
        sign: 'm³/h'
      },
      SingleRingOpts: { title: '高压风机出口流量', labelLineLength: 1, center: ['50%', '60%'], data1Max: 65 },
      RunningTimeData: null,
      SingleSolidPieOpts0: { title: '高压风机出口压力', max: 15000 },
      SingleSolidPieOpts1: { title: '初效过滤压差', max: 200 },
      SingleSolidPieOpts2: { title: '中效过滤压差', max: 200 },
      SingleSolidPieOpts3: { title: '高效过滤压差', max: 200 },
      SingleSolidPieData0: {},
      SingleSolidPieData1: {},
      SingleSolidPieData2: {},
      SingleSolidPieData3: {},
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SinglePieHistogramWrapData: null,
      SinglePieHistogramWrapOpts1: {
        title: '高压风机出口温度温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  created() {
    this.setTitles()
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.setTitles()
    this.resetData()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    this.getDatas()
    // this.getInfo()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
      this.warningFlag6 = ''
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http
        .get(`/bridge/StationInfo?stationId=${stationId}`)
        .then(res => {
          const __data = res.data.deviceList
          const list = __data.map(el => {
            return {
              deviceId: el.deviceId,
              deviceName: el.deviceName
            }
          })
          console.log('list', JSON.stringify(list))
        })
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.$set(this.singleHisOpts, 'title', deviceName[0])
      this.$set(this.SingleSolidPieOpts0, 'title', deviceName[1])
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      console.log('getDatas')
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http
        .get(`/deviceData/Station?stationId=${stationId}`)
        .then(res => {
          this.loadingData = false
          this.$store.commit('setLastRefreshTime')
          const __data = res.data
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData',
            this.findDeviceId(deviceDataName[0]),
            this.findDeviceId(deviceDataName[1]),
            'warningFlag1'
          )
          const findDeviceData2 = this.findDeviceData(__data, deviceDataName[2])
          const findDeviceData3 = this.findDeviceData(__data, deviceDataName[3])
          const findDeviceData4 = this.findDeviceData(__data, deviceDataName[4])
          const findDeviceData5 = this.findDeviceData(__data, deviceDataName[5])
          const findDeviceData6 = this.findDeviceData(__data, deviceDataName[6])
          this.SingleSolidPieData0 = {
            data1: findDeviceData2.value
          }
          this.warningFlag2 = findDeviceData2.errorLevel
          this.flowData = {
            data: findDeviceData3.value
          }
          this.warningFlag3 = findDeviceData3.errorLevel
          this.SingleSolidPieData1 = {
            data1: findDeviceData4.value
          }
          this.warningFlag4 = findDeviceData4.errorLevel
          this.SingleSolidPieData2 = {
            data1: findDeviceData5.value
          }
          this.warningFlag5 = findDeviceData5.errorLevel
          this.SingleSolidPieData3 = {
            data1: findDeviceData6.value
          }
          this.warningFlag6 = findDeviceData6.errorLevel
          this.SwitchStatusData1 = {
            data: __data[this.findDeviceId(deviceDataName[7])].value,
            isError: __data[this.findDeviceId(deviceDataName[7])].errorLevel
          }
          this.SwitchStatusData2 = {
            data: __data[this.findDeviceId(deviceDataName[8])].value,
            isError: __data[this.findDeviceId(deviceDataName[8])].errorLevel
          }
          this.RunningTimeData =
            __data[this.findDeviceId(deviceDataName[9])].value
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dehumidifier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      width: calc(100% / 2 - 8px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      .divice-block-multi-item {
        width: calc(50% - 7px);
      }
    }
    .divice-block-line-item-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-top {
        display: flex;
        justify-content: space-between;
        &-in {
          display: flex;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
  .divice-block-thin {
    height: 42px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .divice-block-time {
    height: calc(100% - 54px);
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
}
</style>
